import './styles.css';
import './app.js';


// só pra garantir que está rodando
console.log('Index.js carregado!');
